import React, { useState, useEffect } from 'react';
import { Button, Input, Row, Col, Label } from 'reactstrap';
import ntc from '../../../utils/ntc';
import styles from './ColorPicker.module.scss';
import { SketchPicker } from 'react-color';
import { BsXCircle } from 'react-icons/bs';
import UploadMedia from '../UploadMedia/UploadMedia';

const ColorPicker = ({ colors, onColorsChange, toggleModal, setModalContent, setModalAction }) => {
    const [selectedColor, setSelectedColor] = useState('#000000'); // Default color
    const [colorList, setColorList] = useState([]);
    const [colorVariationImages, setColorVariationImages] = useState([]);

    useEffect(() => {
        if (colors && colors.length > 0) {
            setColorList(colors);
        } else {
            setColorList([]);
        }
    }, [colors]);

    const addColor = () => {
        if (selectedColor) {
            const n_match = ntc.name(selectedColor);
            const colorName = n_match[1];

            if (colorList.some(colorItem => colorItem.color === selectedColor)) {
                return;
            }

            const updatedColorList = [...colorList, { color: selectedColor, name: colorName }];
            setColorList(updatedColorList);

            onColorsChange(updatedColorList);
        }
    };

    const handleRemoveColor = (colorItem, index) => {
        setModalContent({
            title: 'Confirm Deletion',
            body: `Are you sure you want to delete the option "${colorItem.name}"?`,
            confirmText: 'Yes, Delete',
            cancelText: 'Cancel',
        });

        setModalAction(() => () => {
            const updatedColorList = colorList.filter((_, i) => i !== index);
            setColorList(updatedColorList);
            onColorsChange(updatedColorList);
        });

        toggleModal();
    };

    return (
        <div className={styles.colorPickerContainer}>
            <Row className={styles.colorPickerRow}>
                <Col xs='12' xl={2}>
                    <Label className={styles.label}>Color Options:</Label>
                </Col>
                <Col xs='12' xl={5}>
                    <Row className={styles.colorInputRow}>
                        <Col xs={9}>
                            <SketchPicker
                                color={selectedColor}
                                onChangeComplete={(color) => setSelectedColor(color.hex)}
                                className={styles.colorInput}
                            />
                        </Col>
                        <Col xs={3}>
                            <Button onClick={addColor} className={styles.addButton}>
                                Add
                            </Button>
                        </Col>
                    </Row>
                </Col>
                <Col xs='12' xl={5}>
                    <div className={styles.colorList}>
                        {colorList.map((colorItem, index) => (
                            <div key={index} className={styles.colorItem}>
                                <Button color="danger" onClick={() => handleRemoveColor(colorItem, index)} className={styles.removeColorButton}>
                                    <BsXCircle size={20} />
                                </Button>
                                <span
                                    className={styles.colorBox}
                                    style={{ backgroundColor: colorItem.color }}
                                ></span>
                                <Input
                                    type="text"
                                    value={colorItem.name}
                                    disabled
                                    className={styles.colorName}
                                />
                                <UploadMedia
                                    pictures={colorVariationImages}
                                    setPictures={setColorVariationImages}
                                    maxMedia={1}
                                    allowImages={true}
                                    allowVideos={false}
                                />
                            </div>
                        ))}
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default ColorPicker;